import React from 'react';
import classNames from 'classnames/bind';

// Components
import { Text } from '@beef/ui-kit';
import { FAQ } from 'components';
import { ServiceTerms } from './components/ServiceTerms';

// Utils
import { transformAccordionData } from '../../utils';
import { useInteractionServiceTermsFamily } from './hook';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const ServiceTermsFamily = () => {
  const {
    socketsDescription,
    priceWithoutDiscount,
    discountPriceWithDate,
    discountPrice,
    changedDescription,
    serviceTexts,
  } = useInteractionServiceTermsFamily();

  return (
    <section className={cn('terms')}>
      <div className={cn('terms__service')}>
        <div className={cn('terms__service-title')}>
          <Text size="size3-m">{serviceTexts.serviceTitle}</Text>
        </div>
        <div className={cn('terms__service-details')}>
          <ServiceTerms
            serviceDescription={changedDescription}
            discountPrice={discountPrice}
            discountPriceWithDate={discountPriceWithDate}
            priceWithoutDiscount={priceWithoutDiscount}
            socketsDescription={socketsDescription}
          />
        </div>
      </div>
      <div className={cn('terms__panel')}>
        {serviceTexts?.sections?.map((section, idx) => (
          <FAQ
            key={idx}
            title={section.sectionTitle}
            questions={transformAccordionData(section?.questions)}
          />
        ))}
      </div>
    </section>
  );
};

export { ServiceTermsFamily };
